import { render, staticRenderFns } from "./DocumentEditPricelist.vue?vue&type=template&id=215f2076&"
import script from "./DocumentEditPricelist.vue?vue&type=script&lang=js&"
export * from "./DocumentEditPricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports